(function HotelEngineView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('HotelEngine/view', function onload()
		{
			var processor       = $('.econnect-loader'),
				giata_id        = processor.data('giata-id'),
				search_criteria = processor.data('search-criteria'),
				agent_id        = processor.data('agent-id');

			window.location.href = Adzuki.base_uri + '/HotelEngine/run/' + giata_id + '/' + search_criteria + '/' + agent_id;
		});
	});
}(jQuery, window.Adzuki || {}));
